// Regras únicas para contar e listar: os cartões e as listas usam exatamente as mesmas funções,
// por isso o número de um cartão é sempre igual ao número de linhas da lista que ele abre.
// Os valores guardados na base de dados não mudam (ver src/Contas.js para as fases das comissões).

export const NEG_EM_CURSO = ["proposta", "cpcv_pedido", "cpcv", "cpcv_assinado", "financiamento", "escritura_agendada"];
export const NEG_CONCLUIDO = ["escriturado", "vendido", "arrendado", "fechado"];
export const negEmCurso = (n) => !!n && !n.deleted_at && NEG_EM_CURSO.includes(n.estado);
export const negConcluido = (n) => !!n && NEG_CONCLUIDO.includes(n.estado);

// Sub-abas do separador CPCV
export const FILTROS_CPCV = {
  pedido: (f) => !f.data_assinatura_cpcv,
  assinado: (f) => !!f.data_assinatura_cpcv,
  agendar_escritura: (f) => !!f.data_assinatura_cpcv && !f.escritura_data,
  pleno: (f) => f.angariacao_tipo !== "interna" && f.angariacao_tipo !== "externa",
  interna: (f) => f.angariacao_tipo === "interna" && !!f.partilha_colega,
  externa: (f) => f.angariacao_tipo === "externa",
};
export const filtrarCpcv = (lista, sub) => (FILTROS_CPCV[sub] ? (lista || []).filter(FILTROS_CPCV[sub]) : (lista || []));
export const contarCpcv = (lista) => Object.fromEntries(Object.keys(FILTROS_CPCV).map((k) => [k, filtrarCpcv(lista, k).length]));
// Cartão "CPCV" do painel: CPCV assinados (não conta rascunhos nem apagados)
export const cpcvAssinado = (c) => !!c && !c.deleted_at && FILTROS_CPCV.assinado(c);
